import { Component, Input, OnInit } from '@angular/core';
import { AdditionalInfo, AddressModel, CustomerCreateModel, CustomerModel, CustomerServiceProxy, CustomerStatusModel, CustomerStatusServiceProxy, UtmModel } from '../../../../../shared/service-proxies/event-service-proxy';
import { AuthService } from '../../../../services/auth/auth.service';
import { DestroyService } from '../../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../../services/error/error.service';
import { ToastrService } from '../../../../services/toastr/toastr.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-customer-info-card',
    templateUrl: './customer-info-card.component.html',
    styleUrl: './customer-info-card.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class CustomerInfoCardComponent implements OnInit {
  @Input() customerId: string = '';
  public customer: CustomerModel = new CustomerModel();
  public customerForm: CustomerCreateModel = new CustomerCreateModel();
  private backupCustomerForm: CustomerCreateModel = new CustomerCreateModel();
  public additionalInfo: AdditionalInfo = new AdditionalInfo();
  customerAddressStreet: string = '';
  restoreBtnVisible: boolean = false;
  isLoadingSend: boolean = false;

  public additionalInformation = {
    names: [] as { firstname: string, lastname: string }[],
    phones: [] as string[],
    emails: [] as string[],
    addresses: [] as string[],
  };

  private backupAdditionalInformation = this.additionalInformation;

  private originalAdditionalInformation = this.additionalInformation;

  public additionalInfoVisible = {
    names: false as boolean,
    phones: false as boolean,
    emails: false as boolean,
    addresses: false as boolean
  };

  public sources: UtmModel[] = [
    new UtmModel({source: 'Не выбрано', medium: '', campaign: '', term: '', content: ''}),
    new UtmModel({ source: 'google', medium: '', campaign: '', term: '', content: '' }),
    new UtmModel({ source: 'direct', medium: '', campaign: '', term: '', content: '' }),
    new UtmModel({ source: 'sms', medium: '', campaign: '', term: '', content: '' }),
    new UtmModel({ source: 'email', medium: '', campaign: '', term: '', content: '' }),
    new UtmModel({ source: 'call', medium: '', campaign: '', term: '', content: '' }),
    new UtmModel({ source: 'ktv', medium: '', campaign: '', term: '', content: '' })
  ];
  btnsVisible: boolean = false

  optionsStatus: CustomerStatusModel[] = [];

  constructor(private route: ActivatedRoute, private toastrService: ToastrService, private errorService: ErrorService, private _customerStatusService: CustomerStatusServiceProxy, private _customerServiceProxy: CustomerServiceProxy,  private authService: AuthService, private destroyService: DestroyService) {

  }
  
  ngOnInit(): void {
    console.log(this.sources[0]);
    this.route.paramMap.pipe(takeUntil(this.destroyService.onDestroy$)).subscribe(params => {
      this.customerId = params.get('id') || ''; 
      this.getCustomerInfo();
    })
  }

  get customerAddress() {
    if (!this.customerForm.address) {
      this.customerForm.address = new AddressModel();
    }
    return this.customerForm.address;
  }

  getStatusesCustomer() {
    this._customerStatusService.getAll(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        this.optionsStatus = res;
        console.log(this.optionsStatus);
      })
  }

  getCustomerInfo() {
    this._customerServiceProxy.getDetails(this.customerId)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((customer) => {
        this.customerForm = customer.clone();
        this.customer = customer.clone();
        this.backupCustomerForm = customer.clone();

        customer.additionalInfo?.forEach(info => {
        if (info.additionalFirstname || info.additionalLastname) {
          this.additionalInformation.names.push({
            firstname: info.additionalFirstname || '',
            lastname: info.additionalLastname || '',
          });
        }

        if (info.additionalPhone) {
          this.additionalInformation.phones.push(info.additionalPhone);
        }

        if (info.additionalEmail) {
          this.additionalInformation.emails.push(info.additionalEmail);
        }

        if (info.additionalAddress) {
          this.additionalInformation.addresses.push(info.additionalAddress);
        }
     
        });
        this.originalAdditionalInformation = JSON.parse(JSON.stringify(this.additionalInformation));
        this.getStatusesCustomer();
        if (!this.customer.utmMetadata || !this.customer.utmMetadata.source) this.customerForm.utmMetadata = this.sources[0];
        
      }, error => {
        this.errorService.handleError(error, 'Не удалось получить информацию о клиенте. Попробуйте позже.');
    })
  }

  updateCustomer() {
    console.log(this.customerForm.utmMetadata);
    
    const maxLength = Math.max(
    this.additionalInformation.names.length,
    this.additionalInformation.phones.length,
    this.additionalInformation.emails.length,
    this.additionalInformation.addresses.length
  );

  this.customerForm.additionalInfo = [];

  for (let i = 0; i < maxLength; i++) {
    this.customerForm.additionalInfo.push(
      new AdditionalInfo({
        additionalFirstname: this.additionalInformation.names[i]?.firstname || null,
        additionalLastname: this.additionalInformation.names[i]?.lastname || null,
        additionalPhone: this.additionalInformation.phones[i] || null,
        additionalEmail: this.additionalInformation.emails[i] || null,
        additionalAddress: this.additionalInformation.addresses[i] || null,
      })
    );
  }

    this.isLoadingSend = true;
    this.customerForm.companyId = this.authService.getCompanyId();
    this.customerAddress;
    this._customerServiceProxy.update(this.customerId, this.customerForm)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((res) => {
        this.btnsVisible = false;
        this.restoreBtnVisible = false;
        this.isLoadingSend = false;
        this.customer = res;
        this.toastrService.showSuccessToastr('Информация о клиенте успешно редактирована!');
      }, error => {
        this.isLoadingSend = false;
        this.errorService.handleError(error, 'Не удалось редактировать информацию о клиенте. Попробуйте позже.');
    });
  }

  onCustomerInfoChange(customerKey?: string, index?: number) {
     console.log(this.customerForm[customerKey]);
     
    if (customerKey == 'status' && this.customerForm.status.id !== this.customer.status.id) {
        this.btnsVisible = true;
    } 
     if (this.customerForm[customerKey] !== this.customer[customerKey]) {
        this.btnsVisible = true;
        this.restoreBtnVisible = false;
    } else {
        this.btnsVisible = false;
    }
    
    if (!this.customer[customerKey] && this.customerForm[customerKey] === '') {
        this.btnsVisible = false;
    }
     
    const customerInfo = this.customer.additionalInfo?.[index];

    if (index !== undefined) {
      if (customerKey.includes('additional_firstname') || customerKey.includes('additional_lastname')) {
          
        if (this.additionalInformation.names[index].firstname || this.additionalInformation.names[index].lastname || (customerInfo && (this.additionalInformation.names[index].firstname !== customerInfo.additionalFirstname || this.additionalInformation.names[index].lastname !== customerInfo.additionalLastname))) {
            this.btnsVisible = true;
            this.restoreBtnVisible = false;
              
            } else {
              this.btnsVisible = false;
            }
        }
        
        if (customerKey.includes('additional_phone')) {
            if (this.additionalInformation.phones[index] || (customerInfo && (this.additionalInformation.phones[index] !== this.customer.additionalInfo[index].additionalPhone))) {
                this.btnsVisible = true;
                this.restoreBtnVisible = false;
            } else {
                this.btnsVisible = false;
            }
          if (!this.additionalInformation.phones[index]) {
            this.btnsVisible = false;
          }
        }
        
        if (customerKey.includes('additional_email')) {
            if (this.additionalInformation.emails[index] || (customerInfo && (this.additionalInformation.emails[index] !== this.customer.additionalInfo[index].additionalEmail))) {
                this.btnsVisible = true;
                this.restoreBtnVisible = false;
            } else {
                this.btnsVisible = false;
            }
        }
        
        if (customerKey.includes('additional_address')) {
            if (this.additionalInformation.addresses[index] || (customerInfo && (this.additionalInformation.addresses[index] !== this.customer.additionalInfo[index].additionalAddress))) {
                this.btnsVisible = true;
                this.restoreBtnVisible = false;
            } else {
                this.btnsVisible = false;
            }
        }
    }
}

  resetForm() {
    this.backupCustomerForm = this.customerForm.clone();
    this.customerForm = this.customer.clone();
    this.backupAdditionalInformation = this.additionalInformation;
    this.additionalInformation = JSON.parse(JSON.stringify(this.originalAdditionalInformation))
    this.btnsVisible = false; 
    this.restoreBtnVisible = true; 
  }
  restoreForm() {
    this.customerForm = this.backupCustomerForm.clone();

    this.additionalInformation = this.backupAdditionalInformation;
    this.btnsVisible = true;
    this.restoreBtnVisible = false;
  }
  
  addAdditionalNames() {
    this.additionalInfoVisible.names = true;
    this.additionalInformation.names.push({ firstname: '', lastname: '' });
  }

  addAdditionalPhones() {
    this.additionalInfoVisible.phones = true;
    this.additionalInformation.phones.push('');
  }
  addAdditionalEmails() {
    this.additionalInfoVisible.emails = true;
    this.additionalInformation.emails.push('');
  }
  addAdditionalAddresses() {
    this.additionalInfoVisible.addresses = true;
    this.additionalInformation.addresses.push('');
  }

  removeAdditionalInfo<T extends keyof typeof this.additionalInformation>(key: T, index: number): void {
    if (Array.isArray(this.additionalInformation[key])) {
      const item = this.additionalInformation[key][index];

    if (typeof item === 'string' && item.trim()) {
      this.btnsVisible = true;
    }

    if (typeof item === 'object' && item !== null) {
      const values = Object.values(item).map(v => String(v).trim());
      if (values.some(v => v)) {
        this.btnsVisible = true;
      }
    }

      this.additionalInformation[key].splice(index, 1);
    }
  }

  toggleAdditional(type: keyof typeof this.additionalInfoVisible): void {
    this.additionalInfoVisible[type] = !this.additionalInfoVisible[type];
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
  onPhoneChanged(value: string) {
    this.customerForm.phone = value;
    this.onCustomerInfoChange('phone');
  }

  compareByKey = (a: any, b: any): boolean => {
    if (!a || !b) return false;

    if (a.id !== undefined && b.id !== undefined) return a.id === b.id;
    if (a.name && b.name) return a.name === b.name;
    if (a.source && b.source) return a.source === b.source;

    return false;
  }
}
